import React, { useEffect, useState, useCallback, Fragment } from "react";
import { useLocation } from "react-router";
import { useNavigate, useParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import {
  loadAssessment,
  saveAssessmentStudent,
  saveAssessmentTeam,
} from "../../lib/api/assessment";
import { deleteCompleteQuest } from "../../lib/api/completeQuest";
import {
  AssessmentEditStudentForm,
  AssessmentEditTeamForm,
} from "../../components/assessment/AssessmentEditForm";
import { EmptyBlank } from "../../components/common";

const Edit = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  //console.log(id);
  const {
    state: { student: studentId, team: teamName },
  } = useLocation();
  //console.log("studentId:", studentId, " teamName:", teamName);

  const [assessment, setAssessment] = useState();
  const [student, setStudent] = useState();
  const [team, setTeam] = useState();

  const requestLoadAssessment = useCallback(async () => {
    const { data } = await loadAssessment({ id, studentId, teamName });
    //console.log(data);
    setAssessment(data);
    if (studentId) {
      setStudent(data);
    } else if (teamName) {
      setTeam(data);
    }
  }, [id, studentId, teamName]);

  useEffect(() => {
    requestLoadAssessment();
  }, [requestLoadAssessment]);

  const handleSaveStudet = async ({ grade, memo }) => {
    await saveAssessmentStudent({
      id,
      studentId,
      grade: grade,
      memo: memo,
    });
  };

  const handleSaveTeam = async ({ grade, memo }) => {
    await saveAssessmentTeam({
      id,
      teamName,
      grade: grade,
      memo: memo,
    });
  };

  const handleClose = () => {
    navigate(-1);
  };

  // 완료한 퀘스트를 제거합니다.
  const handleClearQuest = async (e) => {
    if (!student) {
      return;
    }
    if (
      window.confirm(
        "선택한 퀘스트을 초기화하시겠습니까? (복원되지 않습니다. 신중하게 판단하세요.)"
      )
    ) {
      const { value: completeQuestId } = e.target;
      const rsp = await deleteCompleteQuest({
        id: completeQuestId,
      });

      if (rsp.result) {
        setStudent((cur) => {
          const quests = cur.quests.filter(
            (x) => String(x.completedQuestId) !== String(completeQuestId)
          );
          return { ...cur, quests: quests };
        });
      }
    }
  };

  const handelEditStudent = (e) => {
    const targetId = e.target.value;
    navigate(`/students/${targetId}`);
  };

  return (
    <div>
      <Container fluid="md">
        {assessment ? (
          <Fragment>
            {student ? (
              <AssessmentEditStudentForm
                student={student}
                handleSave={handleSaveStudet}
                handleClose={handleClose}
                handleClearQuest={handleClearQuest}
                handelEditStudent={handelEditStudent}
              />
            ) : undefined}
            {team ? (
              <AssessmentEditTeamForm
                team={team}
                handleSave={handleSaveTeam}
                handleClose={handleClose}
                handelEditStudent={handelEditStudent}
              />
            ) : undefined}
          </Fragment>
        ) : undefined}
        <EmptyBlank />
      </Container>
    </div>
  );
};

export default Edit;
